// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","230":"component---src-pages-index-jsx","351":"commons","806":"c0d53ec4"}[chunkId] + "-" + {"218":"e866b0b6f0ce9cfc48f8","230":"4b2ff551fd09dc0997e2","351":"4396c2e1ee041e7c6c0d","806":"3092954bcbf6cf29e632"}[chunkId] + ".js";
};